import RoomSearchParameters from 'src/app/shared/models/roomSearchParams.model';

const availabilityRequiredParams = [
  'timeFrom',
  'timeUntil',
  'numberOfPeople',
  'location',
  'spaceType',
  'date'
];

export const hasAllSearchValues = (params: Partial<RoomSearchParameters>): boolean => {
  return availabilityRequiredParams.every(
    (key) => params[key] !== undefined && params[key] !== null && params[key] !== ''
  );
}
